const _jsxFileName = "";import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    React.createElement(React.StrictMode, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 10}}
      , React.createElement(App, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 11}} )
    )
  );
}